import React from 'react';
import { Calendar, Clock, TrendingUp, X } from 'lucide-react';

const BookingStats = ({ activeBookings = [], inactiveBookings = [] }) => {
  const totalCount = (activeBookings?.length || 0) + (inactiveBookings?.length || 0);
  const pendingCount = (inactiveBookings || []).filter(b => b.status === 'Pending').length;
  const activeCount = activeBookings?.length || 0;
  const cancelledCount = [...(activeBookings || []), ...(inactiveBookings || [])].filter(b => b.status === 'Cancelled').length;

  const stats = [
    { label: 'Total Reservations', value: totalCount, color: 'teal', icon: Calendar },
    { label: 'Pending Approval', value: pendingCount, color: 'amber', icon: Clock },
    { label: 'Active Today', value: activeCount, color: 'emerald', icon: TrendingUp },
    { label: 'Cancelled', value: cancelledCount, color: 'rose', icon: X }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4">
      {stats.map((stat, idx) => {
        const Icon = stat.icon;
        return (
          <div
            key={idx}
            className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between group"
          >
            <div className="flex justify-between items-start mb-2">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-wider">
                {stat.label}
              </span>
              <div className={`w-8 h-8 rounded-xl flex items-center justify-center ${
                stat.color === 'teal' ? 'bg-teal-50 text-[#067978]' :
                stat.color === 'amber' ? 'bg-amber-50 text-amber-600' :
                stat.color === 'emerald' ? 'bg-emerald-50 text-emerald-600' :
                'bg-rose-50 text-rose-600'
              }`}>
                <Icon size={16} />
              </div>
            </div>

            <div>
              <p className="text-xl sm:text-2xl font-black text-slate-800 leading-none">
                {stat.value.toLocaleString()}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BookingStats;
